var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGasSupply(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 256 256",
    enableBackground: "new 0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.13,6.46c0,0-32.5,27-32.5,59.5c0,20.16,14.56,36.5,32.5,36.5c17.95,0,32.5-16.34,32.5-36.5 C80.63,33.46,48.13,6.46,48.13,6.46z M48.13,90.83c-9.11,0-16.5-8.3-16.5-18.53c0-16.5,16.5-30.21,16.5-30.21s16.5,13.71,16.5,30.21 C64.63,82.53,57.25,90.83,48.13,90.83z M249,170h-37.454c-9.038-18.487-28.034-31.253-49.961-31.253S120.662,151.513,111.624,170 H83.75C77.28,170,72,164.73,72,158.25V146h16v-36H8v36h15v12.25C23,194.326,50.751,219,83.75,219h28.052 c9.106,18.297,27.995,30.905,49.783,30.905s40.677-12.608,49.783-30.905H249V170z M200.473,187h-16.465 c-3.092-9.43-11.977-16.26-22.428-16.26c-1.118,0-2.216,0.084-3.294,0.235l-8.357-14.474c3.686-1.138,7.6-1.754,11.655-1.754 C180.905,154.747,197.026,168.665,200.473,187z M122.006,194.326c0-12.037,5.408-22.828,13.914-30.093l8.22,14.237 c-3.812,4.192-6.139,9.759-6.139,15.86c0,5.63,1.987,10.806,5.293,14.867l-8.316,14.404 C127.013,216.357,122.006,205.915,122.006,194.326z M161.585,233.905c-4.495,0-8.812-0.764-12.842-2.15l8.249-14.287 c1.485,0.294,3.018,0.452,4.588,0.452c9.948,0,18.474-6.194,21.94-14.92h16.675C196.228,220.664,180.429,233.905,161.585,233.905z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGasSupply);
export default __webpack_public_path__ + "static/media/gas_supply.c4457c38c0907a3afb978913ae2ebbac.svg";
export { ForwardRef as ReactComponent };